<div class="container mt-5">
    <nb-tabset fullWidth>
        <nb-tab tabTitle="terms-and-conditions">
            <ngx-terms-and-conditions></ngx-terms-and-conditions>
        </nb-tab>
        <nb-tab tabTitle="Privacy Policy">
            <ngx-privacy-policy></ngx-privacy-policy>
        </nb-tab>
        <nb-tab tabTitle="Cookie Policy">
            <ngx-cookie-policy></ngx-cookie-policy>
        </nb-tab>
    </nb-tabset>
</div>
